import React, { Component } from 'react';
import './usageStatsDashboard.scss';
import {
    Card,
    CardBody,
    Row,
    Col,
    Breadcrumb,
    BreadcrumbItem,
    Button
} from 'reactstrap';
import { connect } from 'react-redux'
import { getPortfolioCount } from '../../../Analyst/Cases/Create/actions'
import { setPageView } from '../../../components/GoogleAnalytics/index';
import _ from "lodash";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { listDivision,listUser } from './action';

class UsageStatsDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dropdownOpen: false,
            reportCategoryCount: undefined,
            fromDate:null,
            toDate:null,
            divisionList:[],
            divisionListError:[],
            divisionListOptions:[],
            userList:[],
            userListError:[],
            userListOptions:[],
        };
    }

    componentDidMount = () => {
        // setPageView('/Admin/corporate/list', document.location.href);
        setPageView('/Home', document.location.href);
        this.props.getPortfolioCount();
        const requestBody = {
            corporateName: ""
          }
          this.props.listDivision(requestBody);
          this.props.listUser(requestBody);
    }

    componentDidUpdate(prevProps) {
        let updatedStateObject = {}
        if(this.props.userListOptions !== prevProps.userListOptions){
            this.setState({
                userListOptions:this.props.userListOptions,
            })
        }
        if(this.props.userList !== prevProps.userList){
            this.setState({userList:this.props.userList})
        }

        if(this.props.userListError !== prevProps.userListError){
            this.setState({userListError:this.props.userListError})
        }
        if(this.props.divisionListOptions !== prevProps.divisionListOptions){
            this.setState({
                divisionListOptions:this.props.divisionListOptions,
            })
        }
        if(this.props.divisionList !== prevProps.divisionList){
            this.setState({divisionList:this.props.divisionList})
        }

        if(this.props.divisionListError !== prevProps.divisionListError){
            this.setState({divisionListError:this.props.divisionListError})
        }
        if (this.props.portfolioCount !== prevProps.portfolioCount) {
            console.log(this.props.portfolioCount)
        }
        if (this.props.portfolioCount !== prevProps.portfolioCount){
            this.preferredOrder(this.props.portfolioCount, [
                "INVESTIGATED_REPORT",
                "SUBSCRIPTION_REPORT",
                "KYC_REPORT",
                "OTHERS"
            ]);
        }
    }

    handleFromDateChange = (date)=>{
        this.setState({fromDate:date});

    }

    handleToDateChange=(date)=>{
        this.setState({toDate:date})
    }

    handleSelect = (e, param) => {
        e.preventDefault();
        this.setState({
            selected: param, dropdownOpen: false
        })
    }
    handleChange = (e) => {
        this.setState({ value: e.target.value })

    }
    handleDivisionChange=(e)=>{

    }

    handleUserChange=(e)=>{

    }

    toggleSearchDD = () => {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    preferredOrder = (obj, order) => {
        var newObject = {};
        for(var i = 0; i < order.length; i++) {
            if(obj.hasOwnProperty(order[i])) {
                newObject[order[i]] = obj[order[i]];
            }
        }
        
        this.setState({
            reportCategoryCount: this.objMapper(newObject)
        })
    }

    objMapper = (obj) => {
        let newObj = _.mapKeys(obj, (value, key) => {
           switch (key) {
              case "INVESTIGATED_REPORT":
                 return "Premium Business Check";
              case "SUBSCRIPTION_REPORT":
                 return "Business Profile Report";
              case "KYC_REPORT":
                 return "KYC Report";
              case "OTHERS":
                 return "Other Reports";
              default:
                 return;
             }
           });
        return newObj;
    };

    render() {
    
        return (
            <Col sm="24">
                <Breadcrumb className="mb-3">
                    <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                    <BreadcrumbItem active>Usage Stats</BreadcrumbItem>
                    <BreadcrumbItem active>Dashboard</BreadcrumbItem>
                </Breadcrumb>
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <Row className="dateFilterCard">
                                    <Col sm="4">
                                        <Select
                                            placeholder={'By User...'}
                                            options={this.state.userListOptions}
                                            onChange={this.handleUserChange}
                                        />
                                    </Col>
                                    <Col sm="4">
                                        <Select
                                            placeholder={'By Division...'}
                                            options={this.state.divisionListOptions}
                                            onChange={this.handleDivisionChange}
                                        />
                                    </Col>
                                    
                                    <Col sm="8">
                                        <div className='usageStatsDatePicker'>
                                            <DatePicker 
                                                className="form-control" 
                                                selected={this.state.fromDate ? moment(this.state.fromDate).toDate() : null} 
                                                onChange={date => this.handleFromDateChange(date)} 
                                                placeholderText="FROM DATE: DD-MMM-YYYY" 
                                                dateFormat="dd-MMM-YYYY" 
                                                maxDate={this.state.toDate ? moment(this.state.toDate).toDate() : new Date()} />
                                            <span><i className="icon-minus text-dark"></i></span>
                                            <DatePicker 
                                                className="form-control" 
                                                selected={this.state.toDate ? moment(this.state.toDate).toDate() : null} 
                                                onChange={date => this.handleToDateChange(date)} 
                                                placeholderText="TO DATE: DD-MMM-YYYY" 
                                                dateFormat="dd-MMM-YYYY" 
                                                minDate={this.state.fromDate ? moment(this.state.fromDate).toDate() : null} 
                                                maxDate={new Date()} />
                                        </div>
                                        <div>
                                            <span className="text-danger">{this.state.errorMsg}</span>
                                        </div>
                                    </Col>
                                    <Col sm="2">
                                    <Button className="searchButton" color='primary'>Search</Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className='reportCountCard'>
                    {this.state.reportCategoryCount !== undefined && Object.keys(this.state.reportCategoryCount).map((item, index) =>  <Card key={index}>
                        <CardBody className="text center">
                            <div className="table-responsive table-bordered reportCountTable" style={{background: this.props.corporateColor.colorHexCode}}>
                                <table className="table reportCountTable">
                                    <tbody>
                                    <tr>
                                        <td valign='middle'><p className='reportCount'>{item && Object.values(this.state.reportCategoryCount)[Object.keys(this.state.reportCategoryCount).indexOf(item)]}</p></td>
                                    </tr>
                                     <tr>
                                        <td valign='middle'><p className='reportCountText'>{item && item}</p></td>
                                    </tr>
                                    </tbody>
                                    <Button className="excelDownloadIcon" color='primary'><i className="fa fa-download"></i></Button>
                                </table>
                            </div>
                        </CardBody> 
                    </Card>)} 
                </Row>
            </Col>
        );
    }
}



const mapStateToProps = (state, ownProps) => ({
    portfolioCount: state.createCase.portfolioCountData,
    corporateColor: state.corporate.corporateColor,
    divisionList: state.UsageStatsListData.divisionList,
    divisionListError: state.UsageStatsListData.divisionListError,
    divisionListOptions: state.UsageStatsListData.divisionListOptions,
    userList: state.UsageStatsListData.userList,
    userListError: state.UsageStatsListData.userListError,
    userListOptions: state.UsageStatsListData.userListOptions,
});
const mapDispatchToProps = (dispatch) => ({
    getPortfolioCount: () => { dispatch(getPortfolioCount()) },
    listDivision:(data)=>{dispatch(listDivision(data))},
    listUser:(data)=>{dispatch(listUser(data))},
});
export default connect(mapStateToProps, mapDispatchToProps)(UsageStatsDashboard);